import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, List, ListItemButton, Typography, useMediaQuery, } from '@mui/material';
import PlaceCard from './PlaceCard';
import React from 'react';
import { MAP_SECTION_HEIGHT } from '../../../constants';
import theme from '../../Theming/DefaultTheme';
import TextLink from '../TextLink';
var listItemStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: 5,
};
var PlaceListCard = function (_a) {
    var places = _a.places, loadMoreEnabled = _a.loadMoreEnabled, onPlaceSelected = _a.onPlaceSelected, onPlaceAdded = _a.onPlaceAdded, onLoadMore = _a.onLoadMore;
    var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    var boxStyle = {
        height: isMobile ? '100%' : MAP_SECTION_HEIGHT - 50,
        overflowY: 'auto',
    };
    var handlePlaceSelected = function (selectedPlace) {
        onPlaceSelected(selectedPlace);
    };
    var handlePlaceAdded = function (addedPlace) {
        onPlaceAdded(addedPlace);
    };
    return (_jsxs(Box, { style: boxStyle, sx: {
            '&::-webkit-scrollbar': {
                width: 9,
            },
            '&::-webkit-scrollbar-track': {
                background: 'transparent',
            },
            '&::-webkit-scrollbar-thumb': {
                background: theme.palette.grey[300],
                borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
                background: theme.palette.grey[300],
            },
        }, children: [_jsx(List, { children: places.length > 0 ? (places === null || places === void 0 ? void 0 : places.map(function (place, index) { return (_jsxs(React.Fragment, { children: [_jsx(ListItemButton, { style: listItemStyle, onClick: function () { return handlePlaceSelected(place); }, children: _jsx(PlaceCard, { place: place, onPlaceAdded: handlePlaceAdded }) }), index < places.length - 1 && _jsx(Divider, {})] }, index)); })) : (_jsx(Box, { children: _jsx(Typography, { variant: 'h6', align: 'center', children: "No results found" }) })) }), loadMoreEnabled && (_jsx(Box, { sx: { display: 'flex', justifyContent: 'center', marginBottom: 2 }, children: _jsx(TextLink, { onClick: onLoadMore, children: "Load More" }) }))] }));
};
export default PlaceListCard;
